// extracted by mini-css-extract-plugin
export default {"root":"VEYc9","stepList":"diseX","instruction":"yqHKX"};